import { Injectable } from '@angular/core';
import { DemandeAffiliationStatutConsultant } from '@lib/models/demande-affiliation/types/demande-statut.type';
import { Pagination } from '@lib/models/pagination.model';
import { DemandeCounters } from '../../models/demande-counters.model';
import { DemandeAffiliation } from '@lib/models/demande-affiliation/demande-affiliation.model';
import { Observable } from 'rxjs';

@Injectable()
export abstract class DemandeAffiliationConsultantService {
  public readonly aTraiterStatuts: DemandeAffiliationStatutConsultant[] = [
    'brouillon',
    'nc_a_traiter',
  ];

  public readonly enCoursStatuts: DemandeAffiliationStatutConsultant[] = [
    'en_cours_prodemial',
    'en_signature',
    'soumis_prodemial',
  ];

  public readonly historiqueStatuts: DemandeAffiliationStatutConsultant[] = [
    'affilie',
    'annule',
    'refuse',
    'expire',
  ];

  abstract watchDemandesCountByCategories(): Observable<DemandeCounters>;
  abstract getDemandeAffiliations(
    search: string | null,
    statuts: DemandeAffiliationStatutConsultant[],
    pageIndex: number,
    pageSize: number
  ): Promise<Pagination<DemandeAffiliation>>;
  abstract deleteDemandeAffiliation(publicId: string): Promise<void>;
}
